import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
// golden layout
import {
  GoldenLayoutService,
  GLPopoutConfiguration,
  GLPopoutState,
  GLPopoutUndockBehaviour,
} from "../../golden-layout/golden-layout-service";
import { GoldenLayoutAdditionMode } from "../../golden-layout/golden-layout-addition-mode";
// cubiq
//
import { Subject, Subscription } from "rxjs";

//BFX
import { BfxBlotterActionEvent } from "../../bfx-base-blotter/bfx-base-blotter-contextmenu.service";
import {
  BfxTradeContextMenuService,
  BfxBlotterTradeDialogActionEvent,
} from "./bfx-trade-contextmenu.service";
import { DashboardItemType } from "../../bfx-common/models/dashboard-item-type.enum";
import { BfxBlotterAction, TradeDealPromiseService } from "shared/cubiq-services";
// models
import { BfxDialogData } from "../../bfx-dialogs/models/bfx-dialog-data.model";
import { BfxDialogCommand } from "../../bfx-dialogs/models/bfx-dialog-command.enum";
// base blotter imports
import {
  BfxBaseBlotterActionService,
  ActionListener,
} from "../../bfx-base-blotter/bfx-base-blotter-action.service";

// config
import { BfxConfigService } from "../../../shared/auth-services/system-config/bfx-config.service";
import { BfxVwapTradeService } from "../../bfx-vwap/bfx-vwap-trade.service";

import { LoggerService } from "@bfx/logger";
import { BfxConfigIDRefHelper } from "../../../shared/helper-services/bfx-config-id-ref-helper";

import { BfxRiskTradeBlotterComponent } from "app/bfx-blotter-risk-trade/bfx-risk-trade-blotter.component";
import { BfxFindDealsComponent } from "app/bfx-find-deals/bfx-find-deals.component";
import { DETAILS_MIN_SIZE } from "shared/cubiq-services/model/golden-layout.constants";
const logger = LoggerService.for(__dirname);

@Injectable()
export class BfxTradeActionsService extends BfxBaseBlotterActionService<any> {
  /**********************************************************************/
  /* OBSERVABLE */
  // Observable string sources
  private tradeActionDialogSource = new Subject<BfxDialogData>();
  // Observable string streams
  public dialogCtrl$ = this.tradeActionDialogSource.asObservable();

  protected detailsActionSubscription: Subscription;

  constructor(
    contextMenuService: BfxTradeContextMenuService,
    layoutService: GoldenLayoutService,
    translationService: TranslateService,
    configService: BfxConfigService,
    private tradeDealService: TradeDealPromiseService,
    private vwapTradeService: BfxVwapTradeService,
  ) {
    super(contextMenuService, layoutService, translationService, configService);
  }

  /* CONFIRM TRADE */
  @ActionListener(BfxBlotterAction.ACTION_TRADE_CONFIRM)
  public onConfirmTrade(event: BfxBlotterTradeDialogActionEvent) {
    event.selectedTradeDeals.forEach((tradeDeal) =>
      this.tradeDealService.confirmTradeDeal(tradeDeal).then((res) => {
        if (res === true) {
          //         this._notifyService.notify("success", "Confirm Deal: SUCCESS", "Deal has been successfully confirmed!", "short");//"+res.orderId+"
        } else if (res === false) {
          //         this._notifyService.notify("warning", "Confirm Deal: UNKNOWN", "Unknown response on Deal action! response=" + res, "short");
        } else {
          let msg: string = res; //errors[0].toString();
          logger.out.error("Confirm Deal: FAIL", "ERROR: " + JSON.parse(msg).id, "long");
        }
      }),
    );
  }

  /* CANCEL TRADE */
  @ActionListener(BfxBlotterAction.ACTION_TRADE_CANCEL)
  public onCancelTrade(_event: BfxBlotterTradeDialogActionEvent) {
    this.tradeActionDialogSource.next(
      new BfxDialogData(BfxDialogCommand.DIALOG_TRADE_CANCEL_CONFIRM_OPEN, null, _event, null),
    );
  }

  /* ADD FILL COMMENT */
  @ActionListener(BfxBlotterAction.ACTION_TRADE_ADD_FILL_COMMENT)
  public onAddFillComment(_event: BfxBlotterTradeDialogActionEvent) {
    this.tradeActionDialogSource.next(
      new BfxDialogData(BfxDialogCommand.DIALOG_TRADE_ADD_FILL_COMMENT_OPEN, null, _event, null),
    );
  }

  /* View Order Details */
  @ActionListener(BfxBlotterAction.ACTION_TRADE_VIEW_DETAILS)
  public onViewOrderDetails(_event: BfxBlotterActionEvent) {
    let config: GLPopoutConfiguration = new GLPopoutConfiguration();
    let title: string;

    config.initialState = GLPopoutState.POPOUT;
    config.undockBehaviour = GLPopoutUndockBehaviour.APPLY_BOUNDING_SIZE;
    config.popoutResizable = false;
    config.sourceEvent = _event.sourceEvent;
    config.minimumSize = DETAILS_MIN_SIZE;

    let showRiskTrades: boolean = _event.ladderBlotter instanceof BfxRiskTradeBlotterComponent;
    config.data = { openTradesTab: !showRiskTrades, openRiskTradesTab: showRiskTrades };

    // map from selectedIds, which is is a trade id to order id
    if (
      Array.isArray(_event.selectedItems) &&
      _event.selectedItems.length > 0 &&
      Array.isArray(_event.selectedIds) &&
      _event.selectedIds.length > 0 &&
      _event.selectedIds.length === _event.selectedItems.length &&
      _event.selectedIds[0] === _event.selectedItems[0].id.toString()
    ) {
      config.data.selectedIds = [_event.selectedItems[0].orderId.toString()];
    } else {
      logger.out.error(
        `${this.constructor.name}.onViewOrderDetails invalid mapping between selected ids and items`,
      );
    }
    config.ladderBlotter = _event.ladderBlotter;

    //TODO move to item state as per intervention blotter after this is refactored.
    if (
      Array.isArray(_event.selectedItems) &&
      _event.selectedItems[0] === Object(_event.selectedItems[0]) &&
      typeof _event.selectedItems[0]["orderId"].toString() === "string"
    ) {
      title = this.translationService.instant("order.details.title", [
        BfxConfigIDRefHelper.getOrderRef(_event.selectedItems[0]),
      ]);
    } else {
      title = this.translationService.instant("order.details.title.noid");
    }

    this.layoutService.launchFromDashboard(
      title,
      DashboardItemType.OrderDetails,
      true,
      GoldenLayoutAdditionMode.DEFAULT,
      config,
    );
  }

  /* View Trade/Deal Details */
  @ActionListener(BfxBlotterAction.ACTION_TRADE_VIEW_TRADE_DETAILS)
  public onViewTradeDetails(_event: BfxBlotterActionEvent) {
    let config: GLPopoutConfiguration = new GLPopoutConfiguration();
    config.initialState = GLPopoutState.POPOUT;
    config.undockBehaviour = GLPopoutUndockBehaviour.APPLY_BOUNDING_SIZE;
    config.popoutResizable = false;
    config.ladderBlotter = _event.ladderBlotter;
    config.data = { tradeDealId: _event.selectedIds[0] };
    config.sourceEvent = _event.sourceEvent;
    config.minimumSize = DETAILS_MIN_SIZE;

    let title: string = "Trade Details"; // temp, will be replaced in component when deal is loaded

    this.layoutService.launchFromDashboard(
      title,
      DashboardItemType.DealDetails,
      true,
      GoldenLayoutAdditionMode.DEFAULT,
      config,
    );
  }

  /* TRADE EXPORT */
  @ActionListener(BfxBlotterAction.ACTION_TRADE_EXPORT)
  public onExport(event: BfxBlotterActionEvent) {
    this.tradeActionDialogSource.next(
      new BfxDialogData(BfxDialogCommand.DIALOG_CSV_EXPORT_OPEN, null, event, {
        blotterName: "TradeBlotter",
      }),
    );
  }

  public handleActionEvent(event: BfxBlotterActionEvent) {
    super.handleActionEvent(event);
  }
}
